export const StockStatusEnum = [
    { id: 'FSC', name: 'FCS' },
    { id: 'LSC', name: 'LSC' },
    { id: 'FD', name: 'FD' },
    { id: 'MIX', name: 'MIX' },
    { id: 'PCL', name: 'PCL' },
    { id: 'CO', name: 'CO' },
    { id: 'RET', name: 'RET' },
];